import { useEffect } from 'react';

export const useScrollToAlert = (hasCompetitionValue, alertRef) => {
    const alertTargetElem = alertRef?.current || alertRef;
    const shouldScrollToAlert = hasCompetitionValue && alertTargetElem;

    useEffect(() => {
        if (shouldScrollToAlert) {
            alertTargetElem.scrollIntoView({
                behavior: 'smooth',
            });
        }
    }, [shouldScrollToAlert]);
};
